import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { RefundChargebackReportList } from './RefundChargebackReportList';

export const refundChargebackReportResource: ResourceProps = {
  name: Resources.RefundChargebackReport,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: RefundChargebackReportList,
};
